import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { baseRoute, asyncRoutes } from '@/router';
const state = {
  routes: []
};
const mutations = {
  SET_ROUTE(state, route) {
    state.routes = baseRoute.concat(route);
  },
  RESET_ROUTE(state) {
    state.routes = [];
  }
};
const actions = {
  getRoute({
    commit
  }, {
    role,
    account
  }) {
    return new Promise((resolve, reject) => {
      let accessedRoutes = [];
      accessedRoutes = filterAsyncRoute(asyncRoutes, role, account);
      commit('SET_ROUTE', accessedRoutes);
      resolve(accessedRoutes);
    });
  }

  //仅测试用，生产请去掉
  // async changeRole({ commit, dispatch }) {
  //   await dispatch('user/login');
  //   resetRouter();
  //   const accessedRoutes = await dispatch('getRoute', role);
  //   router.addRoutes(accessedRoutes);
  //   await dispatch('tagsView/clearTag', null, { root: true });
  // }
};
export function filterAsyncRoute(routes, role, account) {
  let arr = [];
  routes.forEach(item => {
    const temp = {
      ...item
    };
    if (hasChildren(temp, role, account)) {
      if (temp.children) {
        temp.children = filterAsyncRoute(temp.children, role, account);
      }
      arr.push(temp);
    }
  });
  return arr;
}
export function hasChildren(route, role, account) {
  let roleIds = role ? role.split(',') : [];
  if (!route.path) {
    return false;
  }
  if (route.meta && route.meta.role) {
    // 超管账号不校验权限
    if (account == 'admin') {
      return true;
    }
    return roleIds.includes(String(route.meta.role));
  } else {
    return true;
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
};